module.exports = __webpack_public_path__ + "media/images/common/hall_of_fame_bg-f061989fedf3263693c75db637cfb566.gif";